<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="360" min-width="320" max-width="320" nudge-bottom="8" content-class="custom-menu")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedOption && selectedValue" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold Balance
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium {{ selectedName }} {{ selectedValue }}
          span(v-if="selectedOption === 'between'") -{{ selectedEndValue }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold Balance

    .pa-4.white(style="border-radius: inherit;")
      .font-semibold.mb-3.text-sm Filter by stock balance
      y-select.mb-2(v-model="option" :items="options" item-value="id" item-text="name" small attach)
      .d-flex.align-start
        v-icon.mx-2(size=16 color="primary") $yzi-corner-down-right
        v-text-field.round-xl(v-model="value" hide-details outlined dense :placeholder="!isBetween ? 'Enter value' : ''" type="number")
        template(v-if="option === 'between'")
          .text-xs.mt-3.mx-2.neutral500--text to
          v-text-field.round-xl(v-model="endValue" hide-details outlined dense :placeholder="!isBetween ? 'Enter value' : ''" type="number")

    .bottom-0.sticky.z-1.white(style="border-radius: inherit;")
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(@click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed) {{ $t('apply') }}

</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: (() => {})
    },
    checkInitialValue: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showMenu: false,
    option: 'stock',
    value: null,
    endValue: null,
    options: [
      { id: 'stock', name: 'Is' },
      { id: 'stock__ne', name: 'Is not' },
      { id: 'stock__lt', name: 'Less than' },
      { id: 'stock__gt', name: 'More than' },
      { id: 'between', name: 'Is between' },
    ],
    selectedOption: null,
    selectedValue: null,
    selectedEndValue: null
  }),
  computed: {
    selectedName () {
      for (const key in this.options) {
        const val = this.options[key]
        if (val.id === this.selectedOption) {
          return val.name
        }
      }
      return null
    },
    isBetween () {
      return this.option === 'between'
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      if (this.checkInitialValue) {
        if (this.filter.key) {
          this.selectedOption = this.filter.key
          this.option = this.filter.key
          if (this.filter.key === 'between' && this.filter.value.length) {
            this.value = this.filter.value[0].value
            this.endValue = this.filter.value[1].value
            this.selectedValue = this.filter.value[0].value
            this.selectedEndValue = this.filter.value[1].value
          } else {
            this.value = this.filter.value
            this.selectedValue = this.filter.value
          }
        }
      }
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.selectedOption = null
      this.value = null
      this.endValue = null
      this.selectedValue = null
      this.selectedEndValue = null
    },
    apply () {
      this.showMenu = false
      this.selectedOption = this.option
      this.selectedValue = this.value
      this.selectedEndValue = this.endValue
      let filter = { key: this.option, value: this.value }
      if (this.option === 'between') {
        filter = { 
          key: this.option, 
          value: [
            { key: 'stock__gte', value: this.value },
            { key: 'stock__lte', value: this.endValue },
          ]
        }
      }
      this.$emit('update:filter', filter)
    },
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
::v-deep {
  .custom-menu {
    overflow: unset;
    contain: unset;
  }
}
</style>